import { render, staticRenderFns } from "./ConstruirPdf.vue?vue&type=template&id=520e2a23&scoped=true&"
import script from "./ConstruirPdf.vue?vue&type=script&lang=js&"
export * from "./ConstruirPdf.vue?vue&type=script&lang=js&"
import style0 from "./ConstruirPdf.vue?vue&type=style&index=0&id=520e2a23&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "520e2a23",
  null
  
)

export default component.exports